import React from 'react';
import './Header.css';
import { CaretDown } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

const Header = () => {

  return (
    <header className="header">
      <Link to="/" className="logo-container">
        <div className="logo-wrapper">
          <div className="logo-layer icon-layer">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR5zi-LeU5pzY_unr4ecjxKxAcNEeBhkV_1Yw&s" alt="Icon" className="logo-img" />
          </div>
          <div className="logo-layer text-layer">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR5zi-LeU5pzY_unr4ecjxKxAcNEeBhkV_1Yw&s" alt="Text" className="logo-img" />
          </div>
        </div>
      </Link>

      <nav className="nav-links">
        <Link to="/" className="nav-link">PORTFOLIO</Link>
        <div className="nav-item">
          <Link to="/services" className="nav-link">SERVICES</Link>
          <CaretDown size={12} weight="bold" color="#ffffff" />
        </div>
        <div className="nav-item">
          <Link to="/industries" className="nav-link">INDUSTRIES</Link>
          <CaretDown size={12} weight="bold" color="#ffffff" />
        </div>
        <div className="nav-item">
          <Link to="/about" className="nav-link">ABOUT US</Link>
          <CaretDown size={12} weight="bold" color="#ffffff" />
        </div>
        <Link to="/insights" className="nav-link">INSIGHTS</Link>
      </nav>

      <Link to="/contact">
        <button className="get-in-touch-btn">
          Get in Touch
        </button>
      </Link>
    </header>
  );
};

export default Header;
